
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Select,
  SimpleGrid,
  Icon,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorModeValue,
  useTheme,
  FormControl,
  FormErrorMessage,
  Input,
  IconButton,
  AlertDialog,
  Alert,
  ModalOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Toast,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';


import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";

// Custom components
import Card from 'components/card/Card';
import InputField from 'components/fields/InputField';

import Confirmar from 'components/fields/DialogoConfirmacion';
import TextField from 'components/fields/TextField';
import TagsField from 'components/fields/TagsField';
import Dropzone from 'views/admin/main/ecommerce/newProduct/components/Dropzone';
import React, { useEffect, useRef, useState } from 'react';
import Hello from './components/TablaDinamica.js';

import { useJwt } from "react-jwt";
import { getCookie } from 'cookies-next';
// Assets
import { MdAdd, MdOutlineCloudUpload, MdPhoto, MdUploadFile } from 'react-icons/md';
import { useForm } from 'react-hook-form'

export default function NewProduct() {
  const inputFileRef = useRef(null);
  const token = getCookie('token')
  const jwt = useJwt(token);

  let valores = JSON.stringify(jwt.decodedToken);
  let valoresx = JSON.parse(valores);
  const toast = useToast()

  const inputFileRefevi = useRef(null);
  const onBtnClick = () => {
    /*Collecting node-element and performing click*/
    inputFileRef.current.click();
  }

  const onBtnClickevi = () => {
    /*Collecting node-element and performing click*/
    inputFileRefevi.current.click();
  }
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const [activeBullets, setActiveBullets] = useState({
    product: true,
    media: false,
    pricing: false,
  });
  const [file, setFile] = useState()
  const [textFile, setTextFile] = useState('')
  const [abierto, setabierto] = useState(false)

  const [candi, setCandi] = useState('') //SELECCION DE CANDIDATO

  const [textFileEvidencia, settextFileEvidencia] = useState('')
  let [NC, setNC] = useState('');

  const [Empresa, setEmpresa] = useState('')
  const [Categoria, setCategoria] = useState('')
  const Clientes = [
    { id: 1, name: 'Alice', country: 'Austria' },
    { id: 2, name: 'Bob', country: 'Belgium' },
    { id: 3, name: 'Carl', country: 'Canada' },
    { id: 4, name: 'Dean', country: 'Denmark' },
    { id: 5, name: 'Ethan', country: 'Egypt' },
  ];



  function handleChange(event: any) {
    setFile(event.target.files[0]);
    try {
      if (event.target?.files[0])

        setTextFile(String(event.target.files[0].name));
    } catch {
      setTextFile('');
      console.log('Sin nombre')
    }
    console.log(event.target.files[0]);
  }

  function handleChangeEvi(event: any) {
    setFile(event.target.files[0]);
    try {
      if (event.target?.files[0])

        settextFileEvidencia(String(event.target.files[0].name));
    } catch {
      settextFileEvidencia('');
      console.log('Sin nombre')
    }
    console.log(event.target.files[0]);
  }

  function handleChangeCliente(event: any) {
    alert(event.target.value)
    //setEmpresa(event.target.value)
  }

  function handleChangeEmpresa(event: any) {
    //alert(event.target.value)
    setEmpresa(event.target.value)
  }

  function handleChangeCategoria(event: any) {
    //alert(event.target.value)

    setCategoria(event.target.value)
  }


  const [message, setMessage] = useState('');


  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()

  function onSubmit(values: any) {
    const answer = window.confirm("Guardar datos?");
    if (answer)
      return new Promise(async (resolve) => {
        const formData = new FormData();

        formData.append('iduser', valoresx.usuarioid); //AQUI  LLAMARA LA SECCION POR DEFAULT DE X USUARIO
        formData.append('Seccion', JSON.parse(candi).value); //AQUI  LLAMARA LA SECCION POR DEFAULT DE X USUARIO
        formData.append('SeccionLabel', JSON.parse(candi).label); //AQUI  LLAMARA LA SECCION POR DEFAULT DE X USUARIO
        //var json = JSON(values, null, 2);
        for (var key in values) {
          console.warn(key)
          let value = values[key];
          formData.append(key, value);
        }
        formData.append('file', file);


        // alert(JSON.parse(candi).value)

        // formData.append('Empresa', Empresa);
        // formData.append('Categoria', Categoria);
        // formData.append('fileName', 'archivito');
        //console.log(formData);
        const response = await fetch(process.env.REACT_APP_URL_SERVER + '/new_votante',
          {
            body: formData,
            method: "post",
            credentials: 'include',
          });
        alert('Votante Guardado')

        // setTimeout(() => {
        //   alert(JSON.stringify(values, null, 2))
        //   //resolve()
        // }, 100)
      })
  }

  const productTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const mediaTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const pricingTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const theme = useTheme();
  //eslint-disable-next-line
  const [lineColor, setLineColor] = useState(theme.colors.brand[500]);
  //eslint-disable-next-line
  const [lineColorDark, setLineColorDark] = useState(theme.colors.brand[400]);
  const brand = useColorModeValue(lineColor, lineColorDark);
  //const {register, handleSubmit, formState: {errors}} = useForm();
  const url = process.env.REACT_APP_URL_SERVER + '/empresas';
  const urlx = process.env.REACT_APP_URL_SERVER + "/secciones";
  const urlMunicipios = process.env.REACT_APP_URL_SERVER + "/municipios";

  const [secciones, setSecciones] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [data1, setData1] = useState([]);
  let genero = [
    { id: "1", valor: "Femenino" },
    { id: "2", valor: "Masculino" },
    { id: "3", valor: "Sin Definir" }
  ]


  const url2 = process.env.REACT_APP_URL_SERVER + '/categorias';
  const [data2, setData2] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure()

  useEffect(() => {
    //
    fetchData();
  }, []);


  const AsyncAlert = (title: any, msg: any) => new Promise((resolve) => {


    // Alert.alert(
    //   title,
    //   msg,
    //   [
    //     {
    //       text: 'ok',
    //       onPress: () => {
    //         resolve('YES');
    //       },
    //     },
    //   ],
    //   { cancelable: false },
    // );
  });

  // await AsyncAlert();
  const fetchData = async () => {
    try {
      // Cargar secciones
      const responsex = await fetch(urlx, { credentials: 'include' });
      const resultx = await responsex.json();
      setSecciones(resultx);

      // Cargar municipios
      const responseMunicipios = await fetch(urlMunicipios, { credentials: 'include' });
      const resultMunicipios = await responseMunicipios.json();
      setMunicipios(resultMunicipios);

      valores = JSON.stringify(jwt.decodedToken);
      valoresx = await JSON.parse(valores);
      setNC(valoresx);

      const response = await fetch(url, { credentials: 'include' });
      const result = await response.json();
      setData1(result);

      const response1 = await fetch(url2, { credentials: 'include' });
      const result1 = await response1.json();
      setData2(result1);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (

    <form onSubmit={handleSubmit(onSubmit)}>

      <Flex
        direction="column"
        minH="100vh"
        align="center"
        pt={{ sm: '125px', lg: '75px' }}
        position="relative"
      >
        {/* {abierto &&
          <Confirmar cabecera='Prueba' boton='Guardar' texto='Desea guardar datos' estado={setabierto}/>

        } */}
        {/* 
        <Box
          h="45vh"
          bgGradient="linear(to-b, brand.400, brand.600)"
          position="absolute"
          w="100%"
          borderRadius="20px"
        /> */}

        <Tabs
        // variant="unstyled"
        // mt={{ base: '60px', md: '165px' }}
        // zIndex="0"
        // display="flex"
        // flexDirection="column"
        >
          <TabPanels mt="24px" maxW={{ md: '90%', lg: '100%' }} mx="auto">
            <TabPanel
              w={{ sm: '330px', md: '700px', lg: '850px' }}
              p="0px"
              mx="auto"
            >
              <Card p="30px">
                <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                  Datos Generales
                </Text>


                <Flex direction="column" w="100%">
                  <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                    <Stack direction="column" gap="20px">
                      <InputField
                        mb="0px"
                        id="Nombre"
                        name="Nombre"
                        placeholder="Emiliano"
                        label="Nombre"
                        nombre="Nombre"
                        required={true}

                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="ApellidoPaterno"
                        name="ApellidoPaterno"
                        placeholder="Torres"
                        label="Apellido Paterno"
                        nombre="ApellidoPaterno"
                        registro={register}
                        required={true}

                      />


                      <InputField
                        mb="0px"
                        id="ApellidoMaterno"
                        name="ApellidoMaterno"
                        placeholder="Garcia"
                        label="Apellido Materno"
                        nombre="ApellidoMaterno"
                        registro={register}
                        required={true}

                      />

                      <InputField
                        mb="0px"
                        id="Telefono"
                        name="Telefono"
                        type='number'
                        placeholder="2411099090"
                        label="Telefono"
                        nombre="Telefono"
                        registro={register}
                        required={true}
                      />

                      <InputField
                        mb="0px"
                        id="Email"
                        name="Email"
                        placeholder="tecnoinnova@ti.com"
                        label="Email"
                        type='email'
                        nombre="Email"
                        registro={register}
                      />
                      <InputField
                        mb="0px"
                        id="Ocupacion"
                        name="Ocupacion"
                        placeholder="Programador"
                        label="Ocupacion"
                        nombre="Ocupacion"
                        registro={register}
                      />

                      {/* <Text style={{fontWeight:'bold',marginBottom:0}}>
                        Cliente
                      </Text> */}
                      {/* <AutoComplete openOnFocus onChange={(key, vals) => console.log(vals)}>
                        <Text style={{ fontWeight: 'bold', marginBottom: 0 }}>
                          Cliente
                        </Text>
                        <AutoCompleteInput variant="filled" placeholder='Selecciona un Cliente' mt={"0px"} mb="0px" />
                        <AutoCompleteList
                          id="Cliente" >
                          {Clientes.map((cliente) => (
                            <AutoCompleteItem
                              key={`option-${cliente.id}`}
                              label={cliente.name}
                              value={cliente.id}
                            >
                              {cliente.name}
                            </AutoCompleteItem>
                          ))}
                        </AutoCompleteList>
                      </AutoComplete> */}
                      <InputField
                        mb="0px"
                        id="Calle"
                        name="Calle"
                        placeholder="Centenario Dpto. C99"
                        label="Calle"
                        nombre="Calle"
                        registro={register}
                        required={true}

                      />

                    </Stack>
                    <Stack direction="column" gap="20px">
                      <InputField
                        mb="0px"
                        id="NVivienda"
                        name="NVivienda"
                        placeholder="Edificio K Depto 280"
                        label="Numero de Vivienda"
                        nombre="NVivienda"
                        registro={register}
                        required={true}

                      />
                      <InputField
                        mb="0px"
                        id="Colonia"
                        name="Colonia"
                        placeholder="San Martin de Porres"
                        label="Colonia"
                        nombre="Colonia"
                        registro={register}
                        required={true}

                      />

                      <InputField
                        mb="0px"
                        id="Referencias"
                        name="Referencias"
                        placeholder="Frente a Seguro Social"
                        label="Referencias"
                        nombre="Referencias"
                        registro={register}

                      />

                      <InputField
                        mb="0px"
                        id="CodigoPostal"
                        name="CodigoPostal"
                        type='number'
                        placeholder="90300"
                        label="Codigo Postal"
                        nombre="CodigoPostal"
                        registro={register}
                        required={true}

                      />

                      <InputField
                        mb="0px"
                        id="Nacimiento"
                        name="Nacimiento"
                        type='date'
                        placeholder="12/12/1993"
                        label="Fecha de Nacimiento"
                        nombre="Nacimiento"
                        registro={register}
                        required={true}

                      />
                      <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Genero"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}

                        >
                          Genero
                        </FormLabel>

                        <Select fontSize="sm"
                          id="Genero"
                          variant="main"
                          h="44px"
                          maxH="44px"
                          name="Genero"
                          // onChange={handleChangeEmpresa}
                          {...register('Genero', { required: true })}

                        >
                          <option> </option>
                          {genero.map((e, key) => {
                            return <option key={key} value={e.id}>{e.valor}</option>;
                          })}
                        </Select>
                      </Flex>

                      <InputField
                        mb="0px"
                        id="CURP"
                        name="CURP"
                        placeholder="CAGY931129"
                        label="CURP"
                        nombre="CURP"
                        registro={register}
                      // required={true}

                      />

                      {/* <InputField
                        mb="0px"
                        id="Seccion"
                        name="Seccion"
                        type='number'
                        placeholder=""
                        label="Seccion"
                        nombre="Seccion"
                        
                        registro={register}
                      /> */}

                      <AutoComplete openOnFocus onChange={(key, vals) => setCandi(JSON.stringify(vals))} >
                        <Text style={{ fontWeight: 'bold', marginBottom: 0 }}>
                          Seccion:
                        </Text>
                        <AutoCompleteInput variant="filled" placeholder='Buscar por municipio o seccion...' mt={"0px"} mb="0px" required={true} />
                        <AutoCompleteList id="SeccionList" maxH="300px" overflowY="auto">
                          {secciones.map((seccion) => (
                            <AutoCompleteItem
                              key={`option-${seccion.id}`}
                              label={`${seccion.Municipio} - ${seccion.Seccion} (${seccion.Tipo})`}
                              value={seccion.id}
                            >
                              <Box>
                                <Text fontWeight="bold">{seccion.Municipio}</Text>
                                <Text fontSize="sm" color="gray.500">
                                  Seccion {seccion.Seccion} - {seccion.Tipo}
                                </Text>
                              </Box>
                            </AutoCompleteItem>
                          ))}
                        </AutoCompleteList>
                      </AutoComplete>

                      {/* <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Categoria"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}
                        >
                          Carga de Factura o Ticket
                        </FormLabel>
                        <Input
                          style={{ display: "none" }}
                          ref={inputFileRef}
                          accept=".pdf,.jpg,.png,.jpeg"
                          id='filex'
                          type="file" onChange={handleChange} />
                        <IconButton onClick={onBtnClick} aria-label={''}>
                          <Icon as={MdUploadFile} h='34px' w='34px' color='red.300' />
                        </IconButton>
                        <Text> Archivo Seleccionado: {textFile}</Text>
                      </Flex> */}


                    </Stack>
                    {/* <Stack direction="column" gap="20px">
                      <Flex>
                        <Hello name='asda' />
                      </Flex>
                    </Stack> */}
                  </SimpleGrid>

                  <Flex direction="column" mb="34px">
                    <FormLabel
                      ms="10px"
                      htmlFor="Categoria"
                      fontSize="sm"
                      color={textColor}
                      fontWeight="bold"
                      _hover={{ cursor: 'pointer' }}
                    >
                      INE                        </FormLabel>
                    <Input
                      style={{ display: "none" }}
                      ref={inputFileRefevi}
                      accept=".png,.jpg,.jpeg"
                      id='filexe'
                      type="file" onChange={handleChangeEvi} />
                    <IconButton onClick={onBtnClickevi} aria-label={''}>
                      <Icon as={MdPhoto} h='34px' w='34px' color='red.300' />
                    </IconButton>
                    <Text> Archivo Seleccionado: {textFileEvidencia}</Text>
                  </Flex>


                  <Flex justify="center" mt="24px">
                    <Button
                      variant="darkBrand"
                      type='submit'
                      fontSize="sm"
                      borderRadius="16px"
                      w={{ base: '128px', md: '148px' }}
                      h="46px"
                    // onClick="rconfirm('Are you sure?')"
                    >
                      Guardar
                    </Button>
                  </Flex>
                </Flex>
              </Card>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmar Guardado</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" mb="34px">
              Esta seguro de guardar los datos?
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={onClose}>
              Cerrar
            </Button>
            <Button colorScheme='green' mr={3} onClick={
              async () => {
                const formData = new FormData();
                const registrationToast = toast({
                  title: "Guardando...",
                  status: "loading",
                });

                handleSubmit(onSubmit)

                toast.close(registrationToast);
                toast({
                  title: "Guardado! :D",
                  status: "success",
                });
              }
            }>
              Subir</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </form>
  );
}
